import * as Banners from './Banners';
export * from './BannersProps';

export default Banners;
